import { apolloVuexSingleStoreFactory } from '../../../libs/ApolloVuexSingleStore'
import { ORGANISATION_APPLE_WALLET_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
let store = apolloVuexSingleStoreFactory({
  settings: {
    fetchQuery: ORGANISATION_APPLE_WALLET_QUERY,
    fetchFieldName: 'organisationAppleWalletSettings',
  }
})
/* eslint-enable no-unused-vars */

export default store